import NativeVideo from "nativevideo-sdk-js";
import {
  InitializeOrgChatParams,
  InitializeOrgChatResponse,
  MessageOrgChatParams,
  MessageOrgChatResponse,
} from "types/orgChat";

/**
 * The VECNA org-chat methods added to nativevideo-sdk-js. Both use the
 * subscriberAuthToken configured on the NativeVideo instance (they throw a 403
 * if it is missing and validate required params with a 400 before requesting).
 *
 * Once the installed nativevideo-sdk-js version types these methods on the
 * NativeVideo class, the cast below can be dropped.
 */
interface OrgChatSdk {
  initializeOrgChat: (
    params: InitializeOrgChatParams
  ) => Promise<InitializeOrgChatResponse>;
  messageOrgChat: (
    params: MessageOrgChatParams
  ) => Promise<MessageOrgChatResponse>;
}

const asOrgChatSdk = (nvObj: NativeVideo): OrgChatSdk =>
  (nvObj as unknown) as OrgChatSdk;

/**
 * Start a new VECNA chat session for the org. Returns the chatId used for every
 * subsequent message, plus the session's expiry timestamp.
 */
export const initializeOrgChat = (
  nvObj: NativeVideo,
  params: InitializeOrgChatParams
): Promise<InitializeOrgChatResponse> => {
  return asOrgChatSdk(nvObj).initializeOrgChat(params);
};

/**
 * Send a message on an existing VECNA chat session and receive the assistant's
 * response along with its supporting sources and a confidence level.
 */
export const messageOrgChat = (
  nvObj: NativeVideo,
  params: MessageOrgChatParams
): Promise<MessageOrgChatResponse> => {
  return asOrgChatSdk(nvObj).messageOrgChat(params);
};
